<template>
    <div class="text-center">
        <supplier-price v-if="!isSupplierPriceTooltip && !isAgency" :supplier-price="room.supplierPrice" />
        <v-tooltip location="top">
            <template v-slot:activator="{props}">
                <v-btn
                    v-if="searchRoomsCount === 1"
                    color="primary"
                    size="small"
                    block
                    variant="flat"
                    max-height="36px"
                    data-cy="client-price"
                    class="mb-2 text-body-2"
                    v-bind="isSupplierPriceTooltip && isSupplierPriceVisible ? props : null"
                    @click="selectForBooking"
                >
                    {{ btnText }}
                    <corporate-policy-violation
                        v-if="room.corporatePolicyViolation && !$breakpoint.smAndDown"
                        :policies="room.corporatePolicy"
                    />
                </v-btn>
                <div
                    v-else-if="showPrice"
                    :class="{'cursor-pointer': isSupplierPriceTooltip && isSupplierPriceVisible}"
                    data-cy="client-price"
                    v-bind="isSupplierPriceTooltip && isSupplierPriceVisible ? props : null"
                >
                    {{ $filters.price(room.price) }}
                </div>
            </template>
            <supplier-price v-if="isSupplierPriceTooltip" class="text-white" :supplier-price="room.supplierPrice" />
        </v-tooltip>
        <div v-if="searchRoomsCount !== 1 && showPrice">
            <corporate-policy-violation
                v-if="room.corporatePolicyViolation && !$breakpoint.smAndDown"
                :policies="room.corporatePolicy"
            />
        </div>
        <template v-if="showPrice">
            <hotel-price-note
                class="hotel-room__note"
                :loyalty-points="room.loyaltyPoints"
                :search-request="searchRequest"
                :rph="rph"
            />
            <discount-label :price="room.price" class="d-inline-block mt-1" />
            <corporate-policy-violation
                v-if="room.corporatePolicyViolation && $breakpoint.smAndDown"
                :policies="room.corporatePolicy"
            />
            <commission-amount :commission="room.price.commission" />
            <net-amount :price="room.price" :search-request="searchRequest" />
            <rate-note :room="room" />
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import DiscountLabel from '~src/components/snippets/discountLabel.src'
    import CommissionAmount from '~/components/snippets/CommissionAmount.vue'
    import NetAmount from '~src/components/snippets/NetAmount'
    import CorporatePolicyViolation from '~/components/snippets/CorporatePolicyViolation.vue'
    import HotelPriceNote from '@/components/hotels/snippets/HotelPriceNote.vue'
    import RateNote from '~src/components/snippets/RateNote.vue'
    import SupplierPrice from '~src/components/snippets/supplierPrice.src'

    @Component({
        components: {
            HotelPriceNote,
            DiscountLabel,
            CommissionAmount,
            NetAmount,
            CorporatePolicyViolation,
            RateNote,
            SupplierPrice,
        },
    })
    export class HotelRoomOfferPriceBlock extends Vue {
        @Prop({default: () => ({})}) room
        @Prop({required: true}) searchRequest
        @Prop({default: () => ({})}) offer
        @Prop({default: 0}) rph

        selectForBooking() {
            const offerKey = [this.room.groupedOffers[0].offerKey]
            hotelsStore.ADD_TO_BASKET(offerKey)
            this.$router.push({
                name: 'hotelBooking',
                query: {offerKey},
            })
        }

        get isSupplierPriceTooltip() {
            return this.$conf.public.isSupplierPriceTooltip || false
        }

        get isSupplierPriceVisible() {
            return this.room.supplierPrice && authStore.companyType && authStore.companyType !== 'CORPORATE'
        }

        get searchRoomsCount() {
            return this.searchRequest.rooms.length
        }

        get showPrice() {
            return true
        }

        get btnText() {
            return this.$filters.price(this.room.price)
        }

        get isAgency() {
            return authStore.isAgency
        }
    }

    export default HotelRoomOfferPriceBlock
</script>
